var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"elevation":"4","tile":""}},[_c('div',{staticClass:"primary dark"},[_c('v-card-title',{staticClass:"white--text"},[_vm._v("INSTITUCIONES")]),_c('v-divider'),_c('v-tabs',{attrs:{"dark":"","background-color":"primary"}},[_c('v-tab',[_vm._v("ADMINISTRACIÓN")]),_c('v-tab-item',[_c('Cpanel')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }